import BadgeIcon from '@mui/icons-material/Badge';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import PeopleIcon from '@mui/icons-material/People';
import SettingsIcon from '@mui/icons-material/Settings';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import StoreMallDirectoryIcon from '@mui/icons-material/StoreMallDirectory';
import { USER_ROLES } from 'data/user/user.constants';
import { useTranslation } from 'react-i18next';

const ALL_ROLES = [USER_ROLES.ADMIN, USER_ROLES.DIRECTOR, USER_ROLES.MANAGER];

const useNavConfig = () => {
  const { t } = useTranslation();
  return [
    {
      title: t('MIJOZLAR'),
      path: '/dashboard/clients',
      icon: <PeopleIcon />,
      roles: ALL_ROLES
    },
    {
      title: t('STATISTIKA'),
      path: '/dashboard/app',
      icon: <SignalCellularAltIcon />,
      roles: ALL_ROLES
    },
    {
      title: t('OMBORXONA'),
      path: '/dashboard/storages',
      icon: <StoreMallDirectoryIcon />,
      roles: ALL_ROLES
    },
    {
      title: t('MAHSULOTLAR'),
      path: '/dashboard/products',
      icon: <ShoppingCartIcon />,
      roles: ALL_ROLES
    },
    {
      title: t('SOZLAMALAR'),
      path: '/dashboard/settings',
      icon: <SettingsIcon />,
      roles: ALL_ROLES
    },
    {
      title: t('HODIMLAR'),
      path: '/dashboard/user',
      icon: <BadgeIcon />,
      roles: ALL_ROLES
    },
    {
      title: t('Tizim qanday ishlaydi?'),
      path: '/dashboard/how-it-works',
      icon: <HelpOutlineIcon />,
      roles: ALL_ROLES
    }
  ];
};

export default useNavConfig;
